<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div class="flex">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small"/>
				<el-button type="warning" style="margin-left: 10px;" @click="getTableData" size="small">搜索</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">拼团状态</div>
				<el-select v-model="status" placeholder="请选择" class="titleSelect" @change="getTableData" size="small">
					<el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">活动日期</div>
				<el-date-picker v-model="dateValue" type="datetimerange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" @change="handelSearchClick" size="small" class="titleDate">
				</el-date-picker>
			</div>
			<div style="flex: 1;text-align: right;">
				<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button class="addClick" @click="handleAddClick" size="small">新建拼团</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<div class="tableView" :style="{height:fixedHeight-82+'px'}">
			<el-table :data="tableData" size="small">
				<el-table-column prop="title" label="拼团名称" :key="1" align="center">
				</el-table-column>
				<el-table-column prop="people" label="参团人数" :key="2" align="center" width="80">
				</el-table-column>
				<el-table-column label="拼团状态" :key="3" align="center" width="80">
					<template slot-scope="scope">
						<div v-if="scope.row.status == 1">未开始</div>
						<div v-if="scope.row.status == 2">进行中</div>
						<div v-if="scope.row.status == 3">已结束</div>
						<div v-if="scope.row.status == 4">已暂停</div>
					</template>
				</el-table-column>
				<el-table-column prop="create_user.operation_user.user_name" label="更新人" :key="5" align="center" width="100">
				</el-table-column>
				<el-table-column prop="online_category_info" label="活动时间" :key="6" align="center" width="320">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.start_time)}}/{{$public.FTime(scope.row.end_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_user.operation_time" label="创建时间" :key="8" align="center" width="140">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.create_user.operation_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="statis_info.order_count" label="订单数量" :key="9" align="center" width="100">
				</el-table-column>
				<el-table-column prop="statis_info.order_money" label="销售总额(元)" :key="10" align="center" width="100">
				</el-table-column>
				<el-table-column label="操作" :key="11" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="scope.row.status == 2" @click="handelShowGroupClick(scope.row)">发起拼团</el-button>
						<el-button type="text" size="small" @click="handelEditClick(scope.row._id)">编辑</el-button>
						<el-button type="text" size="small" @click="handelStartEndClick(scope.row,-1)" v-if="scope.row.status == 2">停止</el-button>
						<el-button type="text" size="small" @click="handelStartEndClick(scope.row,1)" v-if="scope.row.status == 4">启动</el-button>
						<el-button type="text" size="small" v-if="scope.row.status == 3">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
		</div>
		<!-- 发起拼团弹框 -->
		<div v-if="dialogStartGroup_state">
			<dialogStartGroup @closeOn="dialogStartGroup_state = false" :startGroupState.sync="dialogStartGroup_state" :group.sync="groupItem"></dialogStartGroup>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import dialogStartGroup from "../../../components/dialog_startGroup.vue"
	import {
		getList,
		startGroupBook,
		stopGroupBook
	} from '../../../api/program.js'
	export default {
		components: {
			page,
			dialogStartGroup
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				dateValue: [], //活动日期
				keyword: '', //搜索框
				tableData: [], //表格数据
				status:-1,  //拼团状态
				statusOptions:[{
					name:'全部',
					id:-1
				},{
					name:'未开始',
					id:1
				},{
					name:'进行中',
					id:2
				},{
					name:'已结束',
					id:3
				},{
					name:'已暂停',
					id:4
				}],
				dialogStartGroup_state:false,  //发起拼团弹框状态
				groupItem:null, 
				fixedHeight:'',
			}
		},
		mounted() {
			this.getTableData()
		},
		created(){
			this.fixedHeight = document.documentElement.clientHeight - 86;
		},
		methods:{
			//发起拼团
			handelShowGroupClick(row){
				this.dialogStartGroup_state = true;
				this.groupItem = row;
			},
			//上下架
			handelStartEndClick(row,type){
				let that = this;
				let params = {
					id:row._id,
					name:row.title
				}
				if(type == 1){
					startGroupBook(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								type: 'success',
								message: '已启动'
							});
							that.getTableData()
						}
					})
				}else{
					stopGroupBook(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								type: 'error',
								message: '已停止'
							});
							that.getTableData()
						}
					})
				}
			},
			//编辑
			handelEditClick(id){
				this.$router.push({
					path:'addJoin',
					query:{
						id:id,
					}
				})
			},
			//筛选
			handelSearchClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//新建拼团
			handleAddClick(){
				this.$router.push({
					path:'addJoin',
					query:{
						id:''
					}
				})
			},
			//重置
			handleResetClick(){
				this.keyword = '';
				this.status = -1,
				this.dateValue = [];
				this.getTableData()
			},
			//表格方法
			getTableData(){
				let startTime = '';
				let endTime = '';
				console.log(this.dateValue)
				if(this.dateValue.length == 0){
					startTime = '';
					endTime = '';
				}else{
					startTime = new Date(this.dateValue[0]).getTime()/1000;
					endTime = new Date(this.dateValue[1]).getTime()/1000;
				}
				let params = {
					page_index: this.page.page,
					page_size:this.page.pageSize,
					keyword:this.keyword,
					status:this.status,
					start_time:startTime,
					end_time:endTime
				}
				getList(params).then((res)=>{
					if(res.code == 0){
						console.log(res.data)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 14px;
		padding: 0 10px;

		.titleInput {
			width: 160px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-right: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
	}

	.tableView {
		background: #fff;
	}
</style>
